import { Modal, ModalTitle, ModalContent, ModalFooter, Button } from '@utahdts/utah-design-system';
import WaterSystemSearchInput from './WaterSystemSearchInput';
import { useWaterSystemSearchModal } from './WaterSystemSearchModalContext';
import './WaterSystemSearchModal.css';

const WaterSystemSearchModal = ({ selectedWaterSystem, setSelectedWaterSystem }) => {
  const { showSystemSelectModal, setShowSystemSelectModal, setSelectedWaterSystem: setContextWaterSystem } = useWaterSystemSearchModal();

  const handleSetSelectedWaterSystem = (waterSystem) => {
    setSelectedWaterSystem(waterSystem);
    setContextWaterSystem(waterSystem);
  };

  const handleCancel = () => {
    setShowSystemSelectModal(false);
  };

  return (
    <>
      {showSystemSelectModal && (
        <div className="utah-design-system">
          <Modal
            className="modal--medium"
            onClose={handleCancel}
            onEscape={handleCancel}
          >
            <ModalTitle>Select a Water System</ModalTitle>
            <ModalContent id="WS-SearchModal-Content">
              <WaterSystemSearchInput
                setShowSystemSelectModal={setShowSystemSelectModal}
                selectedWaterSystem={selectedWaterSystem}
                setSelectedWaterSystem={handleSetSelectedWaterSystem}
              />
            </ModalContent>
            <ModalFooter id="WS-SearchModal-Footer">
              <Button onClick={handleCancel}>Cancel</Button>
            </ModalFooter>
          </Modal>
        </div>
      )}
    </>
  );
};

export default WaterSystemSearchModal;
